import React from 'react'
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, Tooltip, Legend, XAxis, YAxis } from 'recharts';


const StatisticsGraph = (props) => {
  const { data } = props
  const colors = [
    "#ffc658",
    "#82ca9d",
    "#83a6ed",
    "#d0ed57",
    "#8884d8",
    "#8dd1e1",
    "#a4de6c",
  ]

  const skipFields = [
    'name',
    'site_number',
    'site_country',
  ]
  const bars = Object.keys(data[0]).filter(key => !skipFields.includes(key))
  .map((key, index) => {
    const fill = colors[index % colors.length]
    return (
      <Bar key={key} dataKey={key} fill={fill} />
    )
  })

  return (
    <center>
      <ResponsiveContainer width='90%' height={500}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {bars}
        </BarChart>
      </ResponsiveContainer>
      <br/>
    </center>
  )
}

export default StatisticsGraph
